import _ from 'underscore';
import Backbone from 'backbone';

var Events = {
    ON_COMMENT_DELETED: 'ON_COMMENT_DELETED',
    ON_MAX_CONNECTIONS_MODAL_SHOWED: 'ON_MAX_CONNECTIONS_MODAL_SHOWED',
    ON_MUTUAL_CONNECTIONS_MODAL_SHOWED: 'ON_MUTUAL_CONNECTIONS_MODAL_SHOWED'
};

var ConnectionsDispatcher = _.clone(Backbone.Events);

ConnectionsDispatcher.Events = Events;

export default ConnectionsDispatcher;
